module.exports = __webpack_public_path__ + "img/6-r.7e2ab615.png";